import * as e from "react";
import { c as t } from "../createReactComponent-58f9bea8.mjs";
import { b as r, r as a } from "../menu-3df3d7c3.mjs";
import { c as M, a as l, M as x } from "../menu-3df3d7c3.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
import "../style-map-c3339321.mjs";
const p = t({ tagName: "ex-menu", elementClass: r, react: e, events: { onSelect: "onSelect" }, displayName: "ExMenu", registerWebComponent: a });
export {
  p as ExMenu,
  M as MenuHeight,
  l as MenuVariant,
  x as MenuWidth,
  a as register
};
